import React, { Component, Fragment } from 'react';
import Link from 'redux-first-router-link';
import BodyText from '../Article/ArticleModules/BodyText/BodyText';
import Button from '../common/Button';
import EditorsAndExperts from '../Page/PageModules/EditorsAndExperts/EditorsAndExperts';
import ArticlePickers from './ArticlePickers';
import OurPicks from './OurPicks';
import FeaturedArticle from './FeaturedArticle';
import PropTypes from 'prop-types';
import { isValid, convertArticlesToArray, trimmed, removeTags, decodeTags, getFileName } from '../../utils';
import { APP_ENV, SITE_HOST, AUTHOR_IMAGE_PLACEHOLDER } from '../../consts';

class VerticalModules extends Component {
	constructor() {
		super();
		this.renderEditorsAndExperts = this.renderEditorsAndExperts.bind(this);
		this.renderBodyText = this.renderBodyText.bind(this);
	}

	renderBodyText(data) {
		const encodedData = data;
		return (
			 <div className='vertical-body-text' dangerouslySetInnerHTML={ { __html: encodedData } } />
		)
	}

	renderEditorsAndExperts(hed, cta, data, isMobile, isHomepage) {
		const isVertical = !isHomepage;
		const deepLink = isValid(cta) ? cta : '/page/about-us';
	  	return (
	      <div className="editors-section">
	      	  <div className="section-hed-wrapper col-12 col-4-sm">
				<h2 className="section-hed editor-hed">{hed}</h2>
				{ !isVertical &&
					<Link
					    className="see-more"
					    to={deepLink}
					    target='_blank'
					    onClick={() => {
					      segmentTrackEvent('navigation', { action: 'see_more_clicked', label: 'see more' });
					    }}
					  >
						<div className="see-more-text">See More</div>
					    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					        <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="#1E1E1E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					    </svg>
					</Link>
				}
			  </div>
	          <div className="editor-wrapper col-12 col-4-sm">
	            <EditorsAndExperts data={data} isMobile={isMobile} isPage={false} isVertical={isVertical}/>
	          </div>
	      </div>
	    );
  	}


  	render() {
  		const { modules, isMobile, adUnit, shouldDisplayAds, hasTopFeatured, featuredStories = [], isHomepage = false, firstSet = false, isClient } = this.props;

		const modulesWithAds = shouldDisplayAds ? (() => {
		    const result = [];
	        let adInserted = false;
	        if (isValid(modules)) {
	          modules.forEach((module, i) => {
	            result.push(module);
	            if ((i + 1) % 2 === 0) {
	              const adModule = { type: 'ad' };
	              if (firstSet && !adInserted) {
	                adModule.top = true;
	                adInserted = true;
	              }
	              result.push(adModule);
	            }
	          });
	        }
	        return result;
		      })()
		    : modules;

		const renderedModules = isValid(modulesWithAds) ? modulesWithAds.map((module, i) => {
			switch (module.type) {
			  case 'our-picks':
			      return <OurPicks header={module.data.name} data={module.data} blurb={module.blurb}  isMobile={isMobile} shouldDisplayAds={shouldDisplayAds} isHomepage={isHomepage} isClient={isClient}/>;
			  case 'article-pickers':
			  case 'article-pickers-module':
			      return <ArticlePickers header={module.header} articles={module.data} blurb={module.blurb} pickerType={module.pickerType} isMobile={isMobile} shouldDisplayAds={shouldDisplayAds} isHomepage={isHomepage} isClient={isClient}/>;
			  case 'verticals-editors-and-experts':
			      return this.renderEditorsAndExperts(module.header, module.buttonCTA, module.data, isMobile, isHomepage);
			  case 'body-text':
			  	return <BodyText data={module.data} articleLayout="Standard" className="body-text"/>;
			  case 'featured-story':
			  	return <FeaturedArticle data={module.data} index={i} isMobile={isMobile} hasTopFeatured={hasTopFeatured} featuredStories={featuredStories} />;
			  case 'ad':
			  	return <div 
			  			className={module.top ? 'htlad-purewow_lander_interstitial_top lander-interstital-ad' : 'htlad-purewow_lander_interstitial lander-interstital-ad'}
			  			data-unit={adUnit} 
			  			data-targeting={JSON.stringify({ slot_name: module.top ? 'purewow_lander_interstitial_top' : 'purewow_lander_interstitial' })}>
			  			</div>;
			  default:
			    return null;
			}
		}) : null;

		return (
			<Fragment>
				{renderedModules}
			</Fragment>
		)
	}
}

export default VerticalModules;
